// src/api/TareasVistas/TareasVistasApi.js
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

const auth = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const TareasVistasApi = {
  // 🔹 Obtener tareas no vistas
  getNuevas: async () => {
    try {
      const res = await axios.get(`${API_URL}/api/tareasvistas/nuevas`, {
        headers: auth(),
      });
      return res.data;
    } catch (err) {
      console.error("❌ Error al cargar tareas nuevas:", err.response || err);
      throw err;
    }
  },

  // 🔹 Marcar una tarea individual como vista
  marcarVista: async (id) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/tareasvistas/${id}/vista`,
        {},
        { headers: auth() }
      );
      return res.data;
    } catch (err) {
      console.error("❌ Error al marcar tarea vista:", err.response || err);
      throw err;
    }
  },

  // 🔹 Marcar varias tareas como vistas (en lote)
  marcarVistasEnLote: async (tareaIds) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/tareasvistas/bulk`,
        { tareaIds },
        {
          headers: { ...auth(), "Content-Type": "application/json" },
        }
      );
      return res.data;
    } catch (err) {
      console.error(
        "❌ Error al marcar tareas vistas en lote:",
        err.response || err
      );
      throw err;
    }
  },
};
